import React from 'react'
import { useToleranceGroupInput } from './UseToleranceGroupInput'
import { getToleranceValueLimits, isInvalidToleranceValue } from './toleranceValidation'

type ToleranceGroupInputProps = {
  dbValue: number | null
  field: string
  onChange: (value: number | null) => void
}

export const ToleranceGroupDbInput = ({ dbValue, onChange, field }: ToleranceGroupInputProps) => {
  const { value, handleChange } = useToleranceGroupInput({ dbValue, onChange })

  const { minValue, maxValue } = getToleranceValueLimits(field)

  return (
    <div className="flex">
      <input
        type="number"
        min={minValue}
        max={maxValue}
        className={`border text-center rounded-r-[10px] mr-1 ${
          isInvalidToleranceValue(value === '' ? null : Number(value), field) ? '!border-red' : ''
        }`}
        value={value}
        onChange={handleChange}
        placeholder={`${minValue} - ${maxValue}`}
      />
    </div>
  )
}
